import script from "./DialogDeleteConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogDeleteConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./DialogDeleteConfirm.vue?vue&type=style&index=0&id=6e19782d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e19782d"]])

export default __exports__